'use strict';

angular.module('mobile-apps').controller('InviteUserModalController', [
	'$scope',
	'inputData',
	'EventTracker',
	'$modalInstance',
	'$http',
	function (
		$scope,
		inputData,
		EventTracker,
		$modalInstance,
		$http
	) {

		$scope.credentials = {
			firstName: '',
			lastName: '',
			email: inputData.email
		};

		$scope.processing = false;
		$scope.error = '';

		/**
		 * Invites the user to the team
		 */
		$scope.inviteUser = function () {
			$scope.processing = true;
			$scope.error = '';

			var inviteData = {
				firstName: $scope.credentials.firstName,
				lastName: $scope.credentials.lastName,
				email: $scope.credentials.email,
				role: inputData.role
			};

			$http.post('/v1/teams/' + inputData.teamId + '/invite-user', inviteData).then(function(response) {
				// User got added successfully
				$modalInstance.close();
				$scope.processing = false;

				// Track the User creation
				var eventData = {
					invited_first_name: inviteData.firstName,
					invited_last_name: inviteData.lastName,
					invited_email: inviteData.email,
					invited_role: inviteData.role
				};
				EventTracker.track('User Create Success', 'User Create Invite', eventData);
			}).catch(function(response) {
				$scope.error = response.data.message;
				$scope.processing = false;

				// Track the User creation failed
				var eventData = {
					error_message: response.data.message,
					invited_first_name: inviteData.firstName,
					invited_last_name: inviteData.lastName,
					invited_email: inviteData.email,
					invited_role: inviteData.role
				};
				EventTracker.track('User Create Error', 'User Create Invite', eventData);
			});

		};
	}
]);

